import { NgModule } from '@angular/core';

import { LDComponentsModule } from '../../../ld-angular-components';
import { CommonLibraryModule } from '../../../common-library/common-library.module';
import { modalCompositeComponents } from './components';

@NgModule({
  declarations: [ ...modalCompositeComponents ],
  imports: [
    LDComponentsModule,
    CommonLibraryModule
  ],
  exports: [ ...modalCompositeComponents ]
})
export class ModalCompositesModule {}
